import { render, staticRenderFns } from "./HygienecodeJaarschema.vue?vue&type=template&id=2aaeb55a&scoped=true"
import script from "./HygienecodeJaarschema.vue?vue&type=script&lang=js"
export * from "./HygienecodeJaarschema.vue?vue&type=script&lang=js"
import style0 from "./HygienecodeJaarschema.vue?vue&type=style&index=0&id=2aaeb55a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaeb55a",
  null
  
)

export default component.exports